import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2'
import '../../assets/css/Loader.css'
import AppLoader from '../Components/AppLoader'
import { apiRequest } from '../../apiService/allApi'
function Return ({ walletUpdate }) {

  const history = useHistory()
  var url_string = window.location.href
  var url = new URL(url_string)

  var client_txn_id = url.searchParams.get('client_txn_id')
  var txn_id = url.searchParams.get('txn_id')
  if (client_txn_id && txn_id) {
    var order_id = client_txn_id
    var order_token = txn_id
  } else {
    var order_id = url.searchParams.get('order_id')
    var order_token = url.searchParams.get('order_token')
  }

  const [status, setStatus] = useState()
const returns = async() => {
  let access_token = localStorage.getItem('token')
    access_token = localStorage.getItem('token')
    if (!access_token) {
      window.location.reload()
      history.push('/login')
    }
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    if (client_txn_id && txn_id) {
      const res = await apiRequest(`depositupipay/response`,"POST", { order_id, order_token },headers)
          setStatus(res.data.status)
          const icon = res.data.status == 'PAID' ? 'success' : 'danger'
          const title =
            res.data.status == 'PAID'
              ? 'Deposit submited successfully'
              : 'Transaction Failed'
          walletUpdate()
          history.push('/')
          setTimeout(() => {
            Swal.fire({
              title: title,
              icon: icon,
              confirmButtonText: 'OK'
            })
          }, 1000)
    } else {

      const res = await apiRequest(`deposit/response`,"POST",{ order_id, order_token },headers)

          setStatus(res.data.status)
          const icon = res.data.status == 'PAID' ? 'success' : 'danger'
          const title =
            res.data.status == 'PAID'
              ? 'Deposit submited successfully'
              : 'something went wrong'
          walletUpdate()
          history.push('/')
          setTimeout(() => {
            Swal.fire({
              title: title,
              icon: icon,
              confirmButtonText: 'OK'
            })
          }, 1000)
    }
}

  useEffect(() => {
    returns()
  }, [])

  return (
    <>
      <div
        className='leftContainer page_layout'
        style={{
          position: 'relative'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
          <AppLoader size="lg" color="primary" text="Verifying transaction..." />
        </div>
      </div>
      
    </>
  )
}

export default Return
